import { Html } from "@react-three/drei"
import * as THREE from "three"

export function AxisHelper({ size = 0.125, visible = true }: { size?: number; visible?: boolean }) {
  const lineWidth = 0.008

  if (!visible) return null

  return (
    <group position={[0, 0, 0]}>
      <mesh position={[size / 2, 0, 0]}>
        <boxGeometry args={[size, lineWidth, lineWidth]} />
        <meshBasicMaterial color="red" />
      </mesh>
      <Html position={[size + 0.05, 0, 0]} center>
        <div style={{
          color: 'red',
          fontSize: '14px',
          fontWeight: 'bold',
          userSelect: 'none',
          pointerEvents: 'none'
        }}>
          X
        </div>
      </Html>

      <mesh position={[0, size / 2, 0]}>
        <boxGeometry args={[lineWidth, size, lineWidth]} />
        <meshBasicMaterial color="green" />
      </mesh>
      <Html position={[0, size + 0.05, 0]} center>
        <div style={{
          color: 'green',
          fontSize: '14px',
          fontWeight: 'bold',
          userSelect: 'none',
          pointerEvents: 'none'
        }}>
          Y
        </div>
      </Html>

      <mesh position={[0, 0, size / 2]}>
        <boxGeometry args={[lineWidth, lineWidth, size]} />
        <meshBasicMaterial color="blue" />
      </mesh>
      <Html position={[0, 0, size + 0.05]} center>
        <div style={{
          color: 'blue',
          fontSize: '14px',
          fontWeight: 'bold',
          userSelect: 'none',
          pointerEvents: 'none'
        }}>
          Z
        </div>
      </Html>
    </group>
  )
}
